import styled from 'styled-components';

const DetailUpperBox = styled.div`
  margin-top: 11px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  width: 100%;
  background: #f4f4f7;
  border-radius: 8px;

  hr {
    width: 100%;
    border: none;
    border-top: 1px solid #c9cfd7;
    margin: 8px auto;
  }
`;

const DetailStrong = styled.div`
  height: 20px;
  font-size: 16px;
  line-height: 19px;
  color: #2d1441;
  display: block;
  font-weight: 700;
  width: 100%;
  margin-top: 16px;
`;

const DividerStyled = styled.hr`
  width: 100%;
  border: none;
  margin: 16px auto;
  height: 1px;
  background-image: linear-gradient(to right, transparent 30%, #c9cfd7 0%);
  background-size: 10px 3px;
`;

const AccordionBox = styled.div`
  width: 100%;
  margin: 0 auto 10px;
  display: block;
  height: auto;
`;

const TotalBox = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

const TotalAmount = styled.h2`
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
  color: #0e141d;
`;

export { DetailStrong, DetailUpperBox, DividerStyled, TotalBox, TotalAmount };

export default AccordionBox;
